import {useMutation} from "@apollo/client";
import {CreateAccountDocument, CreateAccountInput} from "generated/graphql";

export const useCreateAccount = () => {
  const [createAccount] = useMutation(CreateAccountDocument);

  return (input: CreateAccountInput) => createAccount({ variables: { input } });
}